import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_3 = { class: "mb-10 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Daftar", -1)
const _hoisted_5 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Sudah memiliki akun ? ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Login disini ")
const _hoisted_8 = { class: "row fv-row mb-7" }
const _hoisted_9 = { class: "col-xl-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Nama Sekolah", -1)
const _hoisted_11 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "row fv-row mb-7" }
const _hoisted_15 = { class: "col-xl-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Email", -1)
const _hoisted_17 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "col-xl-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Nomor Telepon", -1)
const _hoisted_22 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "row fv-row mb-7" }
const _hoisted_26 = { class: "col-xl-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Provinsi", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Provinsi Dahulu", -1)
const _hoisted_29 = ["label", "value"]
const _hoisted_30 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 0,
  class: "col-xl-6"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Kabupaten/ Kota", -1)
const _hoisted_36 = ["label", "value"]
const _hoisted_37 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 1,
  class: "col-xl-6"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_42 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "row fv-row mb-7" }
const _hoisted_46 = {
  key: 0,
  class: "col-xl-6"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Kecamatan", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Kecamatan", -1)
const _hoisted_49 = ["label", "value"]
const _hoisted_50 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  key: 1,
  class: "col-xl-6"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Kecamatan", -1)
const _hoisted_55 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "col-xl-6" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Alamat Lengkap", -1)
const _hoisted_60 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "row fv-row mb-7" }
const _hoisted_64 = { class: "col-xl-6" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Referensi Dari", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Referensi", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", {
  value: "Media Sosial",
  key: "Media Sosial"
}, "Media Sosial", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", {
  value: "Bank",
  key: "Bank"
}, "Bank", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", {
  value: "Webinar",
  key: "Webinar"
}, "Webinar", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("option", {
  value: "Iklan",
  key: "Iklan"
}, "Iklan", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", {
  value: "Relasi",
  key: "Relasi"
}, "Relasi", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("option", {
  value: "Lainnya",
  key: "Lainnya"
}, "Lainnya", -1)
const _hoisted_73 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-warning w-100 mb-5"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Daftar ", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        novalidate: "novalidate",
        onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSubmitRegister())),
        id: "kt_login_signup_form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_router_link, {
                to: "/sign-in",
                class: "link-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: "Isi Nama Sekolah",
                name: "name",
                autocomplete: "off",
                modelValue: _ctx.register.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.register.name) = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.register.name == '' )
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.items.errorname), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                placeholder: "",
                name: "email",
                autocomplete: "off",
                modelValue: _ctx.register.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.register.email) = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              (_ctx.register.email == '' )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.items.erroremail), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "number",
                placeholder: "Isi Nomor Telepon",
                name: "phone",
                autocomplete: "off",
                modelValue: _ctx.register.phone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.register.phone) = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.register.phone == '' )
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.items.errorphone), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_Field, {
                as: "select",
                class: "form-select form-select-lg fw-bold",
                name: "province",
                autocomplete: "off",
                modelValue: _ctx.register.address.province,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.register.address.province) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getKabupaten()))
              }, {
                default: _withCtx(() => [
                  _hoisted_28,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.provinsiOptions, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.id,
                      label: option.name,
                      value: option.name
                    }, null, 8, _hoisted_29))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.register.address.province == '' )
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.items.errorprovince), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_32))
            ]),
            (_ctx.register.address.province != '' )
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "city",
                    autocomplete: "off",
                    modelValue: _ctx.register.address.city,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.register.address.city) = $event)),
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getKecamatan()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_35,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kabupatenOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          label: option.name,
                          value: option.name
                        }, null, 8, _hoisted_36))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.register.address.city == '' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.items.errorcity), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_39))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "detail",
                    class: "form-control form-control-lg",
                    placeholder: "Pilih Kabupaten",
                    disabled: ""
                  }),
                  (_ctx.register.address.city == '' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.items.errorcity), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44))
                ]))
          ]),
          _createElementVNode("div", _hoisted_45, [
            (_ctx.register.address.city != '' )
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _hoisted_47,
                  _createVNode(_component_Field, {
                    as: "select",
                    class: "form-select form-select-lg fw-bold",
                    name: "regency",
                    autocomplete: "off",
                    modelValue: _ctx.register.address.regency,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.register.address.regency) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_48,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.kecamatanOptions, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option.id,
                          label: option.name,
                          value: option.name
                        }, null, 8, _hoisted_49))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.register.address.regency == '' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.items.errorregency), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_52))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "detail",
                    class: "form-control form-control-lg",
                    placeholder: "Pilih Kecamatan",
                    disabled: ""
                  }),
                  (_ctx.register.address.regency == '' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.items.errorregency), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_57))
                ])),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: "Isi Alamat Lengkap",
                name: "detail",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.register.address.detail) = $event))
              }, null, 512), [
                [_vModelText, _ctx.register.address.detail]
              ]),
              (_ctx.register.address.detail == '' )
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.items.errordetail), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_62))
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createVNode(_component_Field, {
                as: "select",
                class: "form-select form-select-lg fw-bold",
                name: "referenceFrom",
                autocomplete: "off",
                modelValue: _ctx.register.referenceFrom,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.register.referenceFrom) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_66,
                  _hoisted_67,
                  _hoisted_68,
                  _hoisted_69,
                  _hoisted_70,
                  _hoisted_71,
                  _hoisted_72
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.register.referenceFrom == '' )
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.items.errorreferenceFrom), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_75))
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("button", _hoisted_77, _hoisted_80, 512)
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}